/*
 * @Author: Json Chen
 * @Date: 2021-09-27 18:49:00
 * @LastEditTime: 2022-06-15 13:19:29
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/DirectDiscount/Detail/CustomerEligible/index.tsx
 */
import React from 'react';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import _DeliveryMethod from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/DeliveryMethod';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const _base = 'discountMethod';
export const _type = [_base, 'deliveryMethod'];
const _methods = [_base, 'specificDeliveryMethods'];

const DeliveryMethod = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disableEdit, options } = props;
  return (
    <SectionWrapper
      containerClassName={`${css.sectionContainer} ${css.sectionContainerWeights}`}
      title={getI18n(
        'salesChannelDirectDiscount.deliveryMethod.deliveryMethod',
      )}>
      <_DeliveryMethod
        radioName={_type}
        methodsName={_methods}
        disableEdit={disableEdit}
        options={options || []}
      />
    </SectionWrapper>
  );
};
export default DeliveryMethod;
